<template>
  <div
    class="flex overflow-y-auto overflow-x-hidden rounded-b-r2 border border-solid border-t-action bg-neutral-50 shadow-md"
  >
    <div class="flex flex-col items-center">
      <Image
        v-if="show_img"
        class="min-h-[100px] w-[210px] rounded-r3 p-4"
        img-classes="!object-fill !rounded-r3"
        :src="image"
      />
      <MenuItem
        v-for="navItem in categories"
        v-bind="navItem"
        class="w-full"
        :test-id="TEST_IDS.NAV_MENU_ITEM"
        @mouseenter="showChildrenMenu(navItem)"
        @click="
          $emit(
            'select',
            navItem.q_key,
            navItem.value,
            undefined,
            navItem.parent_id,
          )
        "
      />
    </div>

    <div
      v-if="selectedItem"
      class="flex flex-col py-3"
      @mouseleave="selectedItem = undefined"
    >
      <p class="px-spacing_8 pt-spacing_6 text-size_5 font-bold">
        {{ selectedItem.label }}
      </p>
      <MenuItem
        v-for="navItemChild in selectedItem.children"
        v-bind="navItemChild"
        class="w-full"
        @click="
          $emit('select', navItemChild.q_key, navItemChild.value, selectedItem)
        "
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NavItemProps } from "~/types/schemas/informative/Molecule/NavItem";
import MenuItem from "~/components/informative/Atom/MenuItem.vue";
import Image from "~/components/common/Atom/Image.vue";
import TEST_IDS from "~~/tests/constants/ids";

defineEmits<{
  select: [
    key: string,
    value: string,
    associatedItem?: NavItemProps,
    parent_id?: string,
  ];
}>();

defineProps<{
  image?: string;
  show_img?: boolean;
  categories?: NavItemProps[];
}>();

const selectedItem = ref<NavItemProps>();

const showChildrenMenu = (navItem: NavItemProps) => {
  if (navItem.children?.length) {
    selectedItem.value = navItem;
  }
};
</script>
